module.exports = __webpack_public_path__ + "rvcnn_business_card_logo_fashion_design_beautiful.jpg?c8c461941303c73094a454c2e88b4ef9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/rvcnn_business_card_logo_fashion_design_beautiful.jpg
// module id = 102
// module chunks = 0